import {
  NAPMYMOBIFONE_COUNT_ASSIGN_SUCCESS,
  NAPMYMOBIFONE_HISTORY_LIST_SUCCESS,
  NAPMYMOBIFONE_IMPORT_SUCCESS,
  NAPMYMOBIFONE_LIST_SUCCESS,
  NAPMYMOBIFONE_NEW_CARE_SUCCESS,
  NAPMYMOBIFONE_ONE_SUCCESS,
  NAPMYMOBIFONECHITIET_ONE_SUCCESS,
  NAPMYMOBIFONE_UPDATE_FILTER,
  NAPMYMOBIFONECHITIET_LIST_SUCCESS,
  NAPMYMOBIFONE_THONG_KE_SUCCESS,
  NAPMYMOBIFONE_DON_CHO_HE_THONG_SUCCESS,
  NAPMYMOBIFONE_UPDATE_FILTER_DON_CHO_HE_THONG,
} from 'src/actions/napmymobifone.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  donchohethongfilter: {
    donchohethongpage: 0,
    donchohethonglimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  thongkeitems: [],
  donchohethongitems: [],
  donchohethongtotal: 0,
  total: 0,
  napmymobifonechitiet_items: [],
  napmymobifonechitiet_total: 0,
  temp: [],
  selected: undefined,
  selectedChiTiet: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const napmymobifoneReducer = (state = initState, action) => {
  switch (action.type) {
    case NAPMYMOBIFONE_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NAPMYMOBIFONE_UPDATE_FILTER_DON_CHO_HE_THONG:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.donchohethongfilter !== 'undefined' && state.donchohethongfilter) {
        if (action.data.donchohethongpage == 'no_update' && typeof state.donchohethongfilter.donchohethongpage !== 'undefined') action.data.donchohethongpage = state.donchohethongfilter.donchohethongpage;
        if (action.data.donchohethonglimit == 'no_update' && typeof state.donchohethongfilter.donchohethonglimit !== 'undefined') action.data.donchohethonglimit = state.donchohethongfilter.donchohethonglimit;
      }
      return {
        ...state,
        donchohethongfilter: action.data,
      }
    }
    case NAPMYMOBIFONECHITIET_LIST_SUCCESS: {
      return {
        ...state,
        napmymobifonechitiet_items: action.data.items,
        napmymobifonechitiet_total: action.data.total,
        napmymobifonechitiet_tong_can_nap: action.data.tong_can_nap,
        napmymobifonechitiet_tong_da_nap: action.data.tong_da_nap,
        napmymobifonechitiet_tong_huy_nap: action.data.tong_huy_nap,
        napmymobifonechitiet_tong_that_bai: action.data.tong_that_bai,
        napmymobifonechitiet_tong_ton_nap: action.data.tong_ton_nap,
      }
    }
    case NAPMYMOBIFONE_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
        tong_can_nap: action.data.tong_can_nap,
        tong_da_nap: action.data.tong_da_nap,
        tong_huy_nap: action.data.tong_huy_nap,
        tong_that_bai: action.data.tong_that_bai,
        tong_ton_nap: action.data.tong_ton_nap,
      }
    }
    case NAPMYMOBIFONE_THONG_KE_SUCCESS: {
      return {
        ...state,
        thongkeitems: action.data.items,
      }
    }
    case NAPMYMOBIFONE_DON_CHO_HE_THONG_SUCCESS: {
      return {
        ...state,
        donchohethongitems: action.data.items,
        donchohethongtotal: action.data.total,
        donchohethong_tong_can_nap: action.data.tong_can_nap,
        donchohethong_tong_da_nap: action.data.tong_da_nap,
        donchohethong_tong_huy_nap: action.data.tong_huy_nap,
        donchohethong_tong_that_bai: action.data.tong_that_bai,
        donchohethong_tong_ton_nap: action.data.tong_ton_nap,
      }
    }
    case NAPMYMOBIFONE_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NAPMYMOBIFONECHITIET_ONE_SUCCESS: {
      return {
        ...state,
        selectedChiTiet: action.data
      }
    }
    case NAPMYMOBIFONE_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NAPMYMOBIFONE_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NAPMYMOBIFONE_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NAPMYMOBIFONE_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default napmymobifoneReducer